import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "auth-page" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = { class: "input-container" }
const _hoisted_5 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "logo" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "background-rectangle" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "username",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event)),
            placeholder: "Email"
          }, null, 512), [
            [_vModelText, $setup.email]
          ]),
          _createVNode($setup["PasswordInput"], {
            class: "password",
            type: "text",
            modelValue: $setup.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
            placeholder: "Password",
            "allow-show": true
          }, null, 8, ["modelValue"])
        ])
      ]),
      ($setup.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Error: " + _toDisplayString($setup.error), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", { class: "btn-container" }, [
        _createElementVNode("button", {
          class: "g-outline-2 login",
          onClick: $setup.login
        }, "Login")
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "right" }, null, -1))
  ]))
}